<div class="scattergories-host-container">
  <div class="page-container">
    <div *ngIf="!gameHasStarted && !gameIsOver">
      <h1>Welcome to the Liars Dice Game!</h1>

      <h2>To Join the game, please connect using this room code: <strong>{{ gameId }}</strong></h2>

      <h2>Players go to <a href="//alpha.tableflip.games/login" target="_blank"><strong>BIT.LY/TBLFLP</strong></a> on your favorite browser to join in on the fun!</h2>
    </div>


    <div class="game-state-container">
      <div *ngIf="gameIsOver">
       <h1 class="game-over">{{ winner }} is the Winner!!!</h1>
        <div class="game-over-btn-container">
          <button mat-raised-button color="primary" class="full-width" (click)="playAgain()">Play Again</button>
          <button mat-raised-button color="secondary" class="full-width" (click)="playAgain(false)">Choose Another Game</button>
        </div>
     </div>

      <div *ngIf="currentSubmitter && currentSubmission && !gameIsOver">
        <h1>Current Submission:</h1>
        <h2>{{ currentSubmitter }} has submitted {{ currentSubmission.count }} - {{ currentSubmission.die }}'s</h2>
      </div>

      <h1 *ngIf="waitingPlayerSubmitterName && !gameIsOver">It is now {{ waitingPlayerSubmitterName }}'s turn to submit their dice guess.</h1>
    </div>

    <div class="connected-users" *ngIf="connectedUsers.length > 0">
      <div class="user-list-container">
        <ul class="user-list">
          <li *ngFor="let connectedUser of connectedUsers">
            <img class="avatar" src="{{ connectedUser.avatar }}">
            <p class="username">
              <strong>{{ connectedUser.name }}</strong><br />
              <strong>{{ connectedUser.currentScore }}</strong>
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
